import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught:', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-[#050505] px-6"
          data-testid="error-boundary"
        >
          <div className="max-w-md w-full bg-[#121212] border border-red-500/30 p-8 text-center">
            <h1 className="font-heading text-2xl text-white uppercase tracking-wide mb-4">
              Something Broke
            </h1>
            <p className="text-zinc-400 text-sm mb-2">
              An unexpected error happened while rendering this page.
            </p>
            <p className="text-red-400 text-xs font-mono mb-6 break-all">
              {this.state.error?.message || 'Unknown error'}
            </p>
            <button
              onClick={this.handleReset}
              className="bg-cyan-400 text-black font-bold uppercase tracking-wide px-6 py-3 hover:bg-cyan-300 transition-colors"
              data-testid="error-boundary-reset"
            >
              Return Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
